$(document).on('Searchanise.ResultsUpdated', () => {
  hideTags();
  handleCollectionDescription();
});

$(document).on('click', '.snize-product-filters-list', function () {
    setTimeout(() => {
        hideTags();
    }, 50);
});







$(document).ready(function(){
  initFP();

  const collection = getUrlParams(location.search).collection;
  
  
  if (collection) {
    $('.mobile-menu').find('li').each((i, li) => {
      if ($(li).data('url') && $(li).data('url') === collection) {
        $(li).parents('ul').show();
        $(li).find('ul').first().show();
      }
    })
  } else {
    const page = (window.location+ '').split('/').slice(-1)[0];
    if (page) {
      $('.mobile-menu').find('li').each((i, li) => {
        if ($(li).data('url') && $(li).data('url') === page) {
          $(li).parents('ul').show();
          $(li).find('ul').first().show();
        }
      })
    }
  }

  if (window.innerWidth >= 1024) {
    checkStickySidebar();
    window.onscroll = function() {checkStickySidebar()};
  }
  var body = document.getElementsByTagName('body')[0];
  var video = document.getElementsByClassName('video')[0];
  if (video) {
    video.setAttribute('playsinline', true);
  }

  $("li.parent").find("a:first").click(function(e){
    e.preventDefault();
    $(this).next().trigger('click');
  });

  // contact form
  yose_contactForm();

  // drop zone

  document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
  const dropZoneElement = inputElement.closest(".drop-zone");
  if (!dropZoneElement) return; // <- skip if no valid parent

  dropZoneElement.addEventListener("click", (e) => {
    inputElement.click();
  });

  inputElement.addEventListener("change", (e) => {
    if (inputElement.files.length) {
      updateThumbnail(dropZoneElement, inputElement.files[0]);
    }
  });

  dropZoneElement.addEventListener("dragover", (e) => {
    e.preventDefault();
    dropZoneElement.classList.add("drop-zone--over");
  });

  ["dragleave", "dragend"].forEach((type) => {
    dropZoneElement.addEventListener(type, (e) => {
      dropZoneElement.classList.remove("drop-zone--over");
    });
  });

  dropZoneElement.addEventListener("drop", (e) => {
    e.preventDefault();

    if (e.dataTransfer.files.length) {
      inputElement.files = e.dataTransfer.files;
      updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
    }

    dropZoneElement.classList.remove("drop-zone--over");
  });
});




  
});

function initFP() {
  var element = document.querySelector('.footerreivews');
  if (!element || element.dataset.m21Scheduled) return;
  element.dataset.m21Scheduled = 'true';
  function start() {
    window.m21LoadOwl().then(function () {
      var $reviews = $(element);
      if ($reviews.hasClass('owl-loaded') || !element.isConnected) return;
      $reviews.owlCarousel({loop:true, margin:5, nav:false, center:false,
        autoplay:true, autoplayTimeout:5000, autoplayHoverPause:true,
        stagePadding:0, responsive:{0:{items:1},600:{items:1},1000:{items:1}}});
    }).catch(function () { element.style.display = 'block'; });
  }
  if ('IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect(); start();
    }, {rootMargin:'200px 0px'});
    observer.observe(element);
  } else start();
}


function yose_contactForm(){
    var $contactForm = $('.contact-form');

    if ( $contactForm.length > 0 ){
      $contactForm.each( function(){
        var el = $(this),
          elResult = el.find('.contact-form-result');

        // Newsletter forms share this class but are not legacy form containers.
        if (!el.find('form').length) return;
        el.find('form').validate({
          showErrors: function(errorMap, errorList) {
            this.defaultShowErrors();
          },
          submitHandler: function(form) {
            elResult.fadeOut( 500 );
            elResult.removeClass('alert alert-danger alert-success')

            $(form).ajaxSubmit({
              target: elResult,
              dataType: 'json',
              success: function( data ) {
                elResult.html( data.message ).fadeIn( 500 );
                elResult[0].scrollIntoView();
                
                if ( data.alert != 'error' ) {
                  elResult.addClass('alert alert-success')
                  
                  $(form).clearForm();
                  setTimeout(function(){
                    elResult.fadeOut( 500 );
                  }, 10000);

                  $(form).addClass('from-sent');
                  
                  document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
                    const dropZoneElement = inputElement.closest(".drop-zone");
                    dropZoneElement.querySelector(".drop-zone__prompt").style.display = 'flex';
                    dropZoneElement.querySelector(".drop-zone__thumb").remove();
                  });
                } else {
                  elResult.addClass('alert alert-danger')
                };
              }
            });
          }
        });

      });
    }
  }


/**
 * Updates the thumbnail on a drop zone element.
 *
 * @param {HTMLElement} dropZoneElement
 * @param {File} file
 */
function updateThumbnail(dropZoneElement, file) {
  let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");


  if (file === null) {
    thumbnailElement = document.createElement("div");
    thumbnailElement.classList.add("drop-zone__thumb");
    dropZoneElement.appendChild(thumbnailElement);
    return;
  }

  // First time - remove the prompt
  if (dropZoneElement.querySelector(".drop-zone__prompt")) {
    dropZoneElement.querySelector(".drop-zone__prompt").style.display = 'none';
  }

  // First time - there is no thumbnail element, so lets create it
  if (!thumbnailElement) {
    thumbnailElement = document.createElement("div");
    thumbnailElement.classList.add("drop-zone__thumb");
    dropZoneElement.appendChild(thumbnailElement);
  }

  thumbnailElement.dataset.label = file.name;

  // Show thumbnail for image files
  if (file.type.startsWith("image/")) {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      thumbnailElement.style.backgroundImage = `url('${reader.result}')`;
    };
  } else {
    thumbnailElement.style.backgroundImage = null;
  }
}


function checkStickySidebar() {
  const sidebar = $('.snize-filters-sidebar').first();
  const content = $('#snize_results').first();
  const footer = $('.box_footer').first();
  const footerHeigh = footer.outerHeight(true) + 48; // 39 is padding between sidebar and footer

  const distanceFromTop = window.pageYOffset
  const distanceFromBottom = document.documentElement.scrollHeight - (distanceFromTop + window.innerHeight);

  if (content.length > 0) {
    const distanceFromBottomOfContent = $(document).height() - (content.offset().top + content.outerHeight());

    if (sidebar.height() < content.height()) {
      if (distanceFromTop <= 92) {
        sidebar.attr('style', 'top: unset;bottom: unset');
      } else if (distanceFromBottom < distanceFromBottomOfContent + 25) { 
        sidebar.attr('style', `top: unset!important; bottom: 0!important;`);
      } else {
        sidebar.attr('style', `top: ${distanceFromTop - 38}px!important;bottom: unset`);
      }
    } 
  }
}
   
    



/**
 * Accepts either a URL or querystring and returns an object associating 
 * each querystring parameter to its value. 
 *
 * Returns an empty object if no querystring parameters found.
 */
function getUrlParams(urlOrQueryString) {
  if ((i = urlOrQueryString.indexOf('?')) >= 0) {
    const queryString = urlOrQueryString.substring(i+1);
    if (queryString) {
      return _mapUrlParams(queryString);
    } 
  }
  
  return {};
}

/**
 * Helper function for `getUrlParams()`
 * Builds the querystring parameter to value object map.
 *
 * @param queryString {string} - The full querystring, without the leading '?'.
 */
function _mapUrlParams(queryString) {
  return queryString    
    .split('&') 
    .map(function(keyValueString) { return keyValueString.split('=') })
    .reduce(function(urlParams, [key, value]) {
      if (Number.isInteger(parseInt(value)) && parseInt(value) == value) {
        urlParams[key] = parseInt(value);
      } else {
        urlParams[key] = decodeURI(value);
      }
      return urlParams;
    }, {});
}


function hideTags() {
  const keywords = ['IMPORTED', 'ACTION REQUIRED', 'HANDLED'];

  $('#snize_filters_block_tags label, #snize_product_filter_tags label').each(function () {
    const text = $(this).text().toUpperCase();
    if (keywords.some(keyword => text.includes(keyword))) {
      $(this).hide();
    }
  });
}


function handleCollectionDescription() {
  const $header = $('.collection-header');
  const $shortDesc = $('.collection-description-short'); // original Liquid
  const $fullDesc = $('#full-description');

  if (window.location.pathname.endsWith('/collections/compatible-parts')) {
    $header.hide();
    $shortDesc.hide();
    $fullDesc.hide();
  } else {
    $header.hide();

    // Always ensure short description is under Searchanise title
    const $snizeTitle = $('.snize-main-panel-collection-results-found');
    if ($snizeTitle.length && $('#snize-short-description').length === 0 && $shortDesc.length) {
      const cloned = $shortDesc.clone()
        .attr('id', 'snize-short-description')
        .addClass('snize-short-clone')
        .show();

      $snizeTitle.after(cloned);
      $shortDesc.hide();
    }

    // Always ensure full description is under results (new id)
    if ($('#snize_results').length && $('#collection-description').length === 0 && $fullDesc.length) {
      const clonedFull = $fullDesc.clone()
        .attr('id', 'collection-description')
        .addClass('snize-full-clone')
        .show();

      $('#snize_results').after(clonedFull);
      $fullDesc.hide();
    }

    // Update "Read more" button target if clone exists
    if ($('#collection-description').length) {
      $('.snize-short-clone .read-more-btn').attr('href', '#collection-description');
    }
  }
}

// Pre-order & Restock Notifier app button: reuse the exact same
// text-slides-up / cart-icon-slides-in hover markup as .product__add-to-cart,
// so it looks and behaves identically on hover.
(function() {
  var cartSvg = '<svg class="svg symbol symbol--cart" width="22" height="22" viewBox="0 0 892 1000" xmlns="http://www.w3.org/2000/svg"><path transform="translate(0,850) scale(1,-1)" d="M696 599c-7 56-32 109-73 149-47 47-109 72-175 72h-4c-66 0-128-25-175-72-41-40-66-93-72-149h-167v-554c0-91 74-165 165-165h502c91 0 166 74 166 165v554h-167z m-252 169h4c99 0 181-74 195-169h-394c14 95 96 169 195 169z m366-723c0-62-50-113-113-113h-502c-62 0-113 51-113 113v502h117v-102c0-12 10-22 22-22h2c12 0 22 10 22 22v102h402v-102c0-12 10-22 22-22h2c12 0 22 10 22 22v102h117v-502z"/></svg>';

  var restockCopy = {
    lt: { title: 'Gaukite pranešimą apie prieinamumą', description: 'Palikite savo el. pašto adresą. Pranešime, kai šią prekę vėl bus galima užsisakyti.', email: 'Jūsų el. pašto adresas', button: 'Pranešti man' },
    et: { title: 'Saa teavitus saadavuse kohta', description: 'Jäta oma e-posti aadress. Anname teada, kui seda toodet saab taas tellida.', email: 'Sinu e-posti aadress', button: 'Teavita mind' },
    en: { title: 'Get notified when available', description: 'Leave your email address. We will let you know when this product is available to order again.', email: 'Your email address', button: 'Notify me' }
  };
  function upgradePreorderButtons() {
    var copy = restockCopy[(document.documentElement.lang || '').toLowerCase().split('-')[0]];
    if (copy) {
      document.querySelectorAll('.news-signform-wrap').forEach(function(form) {
        var title = form.querySelector('.popup-title');
        var description = form.querySelector('.popup-desc');
        var email = form.querySelector('input[name="exoemail"]');
        var submit = form.querySelector('#exoNotifySubmit');
        if (title && title.textContent !== copy.title) title.textContent = copy.title;
        if (description && description.textContent !== copy.description) description.textContent = copy.description;
        if (email && email.placeholder !== copy.email) email.placeholder = copy.email;
        if (email && email.getAttribute('aria-label') !== copy.email) email.setAttribute('aria-label', copy.email);
        if (submit && submit.value !== copy.button) submit.value = copy.button;
      });
    }
    document.querySelectorAll('.ct-preorder-btn').forEach(function(btn) {
      if (!btn.querySelector('.add-to-cart__symbol')) {
        btn.classList.add('product__add-to-cart');
        var text = btn.textContent.trim();
        btn.innerHTML =
          '<span class="add-to-cart__text">' + text + '</span>' +
          '<span class="add-to-cart__symbol" aria-hidden="true">' + cartSvg + '</span>';
      }

      // The app inserts this button as a sibling right after .flex-buttons closes,
      // pulling it out of the same flex row as quantity/wishlist. Move it back in,
      // so it lands at the end of that row like the real add-to-cart button does.
      var sourceLabel = btn.form && btn.form.querySelector('[data-js-product-add-to-cart-text]');
      var targetLabel = btn.querySelector('.add-to-cart__text');
      if (sourceLabel && targetLabel && targetLabel.textContent !== sourceLabel.textContent) {
        targetLabel.textContent = sourceLabel.textContent;
      }
      var cartFunctions = btn.closest('.product__cart-functions');
      var flexButtons = cartFunctions && cartFunctions.querySelector('.flex-buttons');
      if (flexButtons && btn.parentElement !== flexButtons) {
        flexButtons.appendChild(btn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradePreorderButtons);
  } else {
    upgradePreorderButtons();
  }

  var restockUpdateQueued = false;
  var restockTargets = '.news-signform-wrap, .ct-preorder-btn, [data-js-product-add-to-cart-text]';
  new MutationObserver(function (records) {
    if (restockUpdateQueued) return;
    var relevant = records.some(function (record) {
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target && target.closest(restockTargets)) return true;
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches(restockTargets) || node.querySelector(restockTargets));
      });
    });
    if (!relevant) return;
    restockUpdateQueued = true;
    requestAnimationFrame(function () {
      restockUpdateQueued = false;
      upgradePreorderButtons();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

(function () {
  var CACHE_KEY = 'moto_weather_cache';
  var CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minūtes

  // Read Shopify's localized section settings; no client-side translation app is required.
  function weatherLabel(container, key, fallback) {
    return container.getAttribute('data-i18n-' + key.replace(/_/g, '-')) || fallback;
  }

  function initWeatherWidget(container) {
    var defaultCity = container.dataset.defaultCity || 'Jelgava';
    var defaultLat = parseFloat(container.dataset.defaultLat) || 56.65;
    var defaultLon = parseFloat(container.dataset.defaultLon) || 23.71;

    var cachedData = localStorage.getItem(CACHE_KEY);

    if (cachedData) {
      var parsedData = JSON.parse(cachedData);
      var now = new Date().getTime();

      if (now - parsedData.timestamp < CACHE_DURATION_MS) {
        displayWeather(container, parsedData.weatherData, parsedData.city);
        return;
      }
    }

    fetch('https://ipapi.co/json/')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var city = data.city ? data.city : defaultCity;
        var lat = data.latitude ? data.latitude : defaultLat;
        var lon = data.longitude ? data.longitude : defaultLon;
        fetchWeatherFromAPI(container, lat, lon, city);
      })
      .catch(function () {
        fetchWeatherFromAPI(container, defaultLat, defaultLon, defaultCity);
      });
  }

  function fetchWeatherFromAPI(container, lat, lon, cityName) {
    var url = 'https://api.met.no/weatherapi/locationforecast/2.0/compact?lat=' + lat + '&lon=' + lon;

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          timestamp: new Date().getTime(),
          weatherData: data,
          city: cityName
        }));

        displayWeather(container, data, cityName);
      })
      .catch(function () {
        container.querySelector('#moto-advice').innerText = weatherLabel(container, 'error_loading', 'Īslaicīgas problēmas ar laikapstākļu datu ielādi.');
        container.querySelector('#moto-advice').style.borderLeftColor = '#e74c3c';
        container.querySelector('#weather-city').innerText = cityName;
      });
  }

  // Uzlabota sajūtu temperatūras funkcija (ņem vērā gan vēju, gan mitrumu pie jebkuras temperatūras)
  function getApparentTemperature(tempC, windMs, humidity) {
    var windKmh = windMs * 3.6;
    var feelsLike = tempC;

    // Ja ir auksts (<= 10°C) un pūš vējš, piemērojam Wind Chill
    if (tempC <= 10 && windKmh > 4.8) {
      feelsLike = 13.12 + 0.6215 * tempC - 11.37 * Math.pow(windKmh, 0.16) + 0.3965 * tempC * Math.pow(windKmh, 0.16);
    }
    // Ja ir vēsāks vai mērens laiks (piem., 10°C - 20°C) ar mērenu/stipru vēju, vējš tāpat atdzesē
    else if (windKmh > 5) {
      feelsLike = tempC - (windKmh * 0.15); // Vienkāršots koeficients vēja ietekmei virs 10 grādiem
    }

    return Math.round(feelsLike);
  }

  function displayWeather(container, data, cityName) {
    try {
      var details = data.properties.timeseries[0].data.instant.details;
      var symbolCode = data.properties.timeseries[0].data.next_1_hours.summary.symbol_code;

      var temp = Math.round(details.air_temperature);
      var windMs = details.wind_speed || 0;
      var humidity = details.relative_humidity || 70;

      var feelsLike = getApparentTemperature(temp, windMs, humidity);

      container.querySelector('#weather-city').innerText = cityName;
      container.querySelector('#weather-temp').innerText = temp + '°C';

      var feelsLikeEl = container.querySelector('#weather-feels-like');
      feelsLikeEl.innerText = weatherLabel(container, 'feels_like', 'Sajūtu: [temperature]°C').replace('[temperature]', feelsLike);
      feelsLikeEl.style.display = 'block';

      var iconEl = container.querySelector('#weather-icon');
      iconEl.src = 'https://raw.githubusercontent.com/metno/weathericons/main/weather/svg/' + symbolCode + '.svg';
      iconEl.alt = "";
      iconEl.style.display = 'block';

      var weatherText = weatherLabel(container, 'weather_default', 'Skaidrs / Mākoņains');
      if (symbolCode.includes('rain')) weatherText = weatherLabel(container, 'weather_rain', 'Lietus');
      if (symbolCode.includes('snow') || symbolCode.includes('sleet')) weatherText = weatherLabel(container, 'weather_snow', 'Sniegs vai slapjš sniegs');
      if (symbolCode.includes('cloud')) weatherText = weatherLabel(container, 'weather_cloud', 'Mākoņains');
      if (symbolCode.includes('fog')) weatherText = weatherLabel(container, 'weather_fog', 'Migla');
      if (symbolCode.includes('thunder')) weatherText = weatherLabel(container, 'weather_thunder', 'Pērkona negaiss');
      if (symbolCode.includes('clearsky') || symbolCode.includes('fair')) weatherText = weatherLabel(container, 'weather_clear', 'Skaidrs laiks');

      container.querySelector('#weather-desc').innerText = weatherText;
      iconEl.alt = weatherText;

      var titleEl = container.querySelector('#widget-title');
      if (feelsLike < 15 || symbolCode.includes('snow') || symbolCode.includes('sleet')) {
        titleEl.innerText = weatherLabel(container, 'title_weather', 'Moto Laikapstākļi');
      } else {
        titleEl.innerText = weatherLabel(container, 'title_ride', 'Laiks Izbraucienam');
      }

      var advice = '';
      var borderColor = '#ccc';

      if (symbolCode.includes('snow') || symbolCode.includes('sleet') || feelsLike < 5) {
        advice = weatherLabel(container, 'advice_winter', 'Ziemas sezona vai ļoti zema sajūtu temperatūra. Šis ir piemērots laiks motocikla ieziemošanai, tehniskajai apkopei un akumulatora uzlādei.');
        borderColor = '#bdc3c7';
      } else if (symbolCode.includes('rain') || symbolCode.includes('thunder')) {
        advice = weatherLabel(container, 'advice_wet', 'Nokrišņi un pazemināta redzamība. Iesakām izmantot ūdensnecaurlaidīgu ekipējumu un rēķināties ar garāku bremzēšanas ceļu.');
        borderColor = '#3498db';
      } else if (feelsLike >= 5 && feelsLike < 10) {
        advice = weatherLabel(container, 'advice_cold', 'Zema gaisa temperatūra samazina riepu saķeri ar asfaltu. Ieteicams izmantot siltinātu bāzes slāni un pretvēja ekipējumu.');
        borderColor = '#95a5a6';
      } else if (feelsLike >= 10 && feelsLike < 15) {
        advice = weatherLabel(container, 'advice_cool', 'Vēss, bet braukšanai piemērots laiks. Pirms došanās ceļā aicinām pārbaudīt riepu spiedienu un izvēlēties atbilstošu apģērbu.');
        borderColor = '#34495e';
      } else if (feelsLike >= 15 && feelsLike <= 25) {
        advice = weatherLabel(container, 'advice_mild', 'Optimāli laikapstākļi braukšanai ar motociklu. Izbaudiet braucienu un ievērojiet drošību uz ceļa.');
        borderColor = '#2ecc71';
      } else if (feelsLike > 25) {
        advice = weatherLabel(container, 'advice_hot', 'Augsta gaisa temperatūra. Ilgākos braucienos iesakām izmantot ventilējamu ekipējumu un regulāri uzņemt šķidrumu.');
        borderColor = '#e67e22';
      } else {
        advice = weatherLabel(container, 'advice_default', 'Piemēroti laikapstākļi braukšanai. Ievērojiet drošību uz ceļa.');
        borderColor = '#34495e';
      }

      var adviceEl = container.querySelector('#moto-advice');
      adviceEl.innerText = advice;
      adviceEl.style.borderLeftColor = borderColor;
    } catch (error) {
      console.error('Kļūda apstrādājot laikapstākļu datus:', error);
    }
  }

  function initAll() {
    document.querySelectorAll('#moto-weather-widget-container').forEach(function (container) {
      if (container.dataset.weatherInitialized) return;
      container.dataset.weatherInitialized = 'true';
      initWeatherWidget(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
